export default "__VITE_ASSET__Dbcje6KY__"